import React, { useEffect } from "react";
import { connect } from "react-redux";
import authActions from "../../../store/actions/authActions";
import typeMessageClass from "../../../messages/typeClass";
import { Redirect, Link } from "react-router-dom";
import helperNumber from "../../../helpers/numbers";

let timer, timeleft;
const startTimer = () => {
  timeleft = 59;
  timer = setInterval(function () {
    if (timeleft <= 0) {
      clearInterval(timer);
      document.getElementById("countdown").innerHTML = "٠٠:٠٠";
    } else {
      document.getElementById("countdown").innerHTML =
        "٠٠:" + helperNumber.toPersianNum(timeleft);
    }
    timeleft -= 1;
  }, 1000);
};

function LoginWithMobile({
  mobile,
  authStatus,
  isUserLoggedIn,
  hasMessage,
  typeMessage,
  message,
  sendMobileUserForLoign,
  checkSmsCodeMobileForLogin,
  returnToEnterUserMobilerForLogin,
}) {
  startTimer();

  if (authStatus === null) {
    clearInterval(timer);
    return <Redirect to="/enter-mobile-for-login" />;
  }

  if (isUserLoggedIn === true) {
    return <Redirect to="/" />;
  }

  let messageComponent;
  if (hasMessage == true) {
    messageComponent = (
      <div className="w-100">
        <p className={typeMessageClass[typeMessage]}>
          <span> {message}</span>
        </p>
      </div>
    );
  }

  const submitFormEnterCodeMobileNumberForLoign = (e) => {
    e.preventDefault();

    const smsCode = document.getElementById("code-sms-mobile").value;

    const action = {
      smsCode: smsCode,
      mobile: mobile,
    };

    checkSmsCodeMobileForLogin(action);
  };

  window.onload = () => {
    document.getElementById("code-sms-mobile").focus();
  };

  const sendSmsLoginCodeAgainHandler = (e) => {
    e.preventDefault();

    if (timeleft <= 0) {
      sendMobileUserForLoign(mobile);
      startTimer();
    } else {
      alert("شما باید یک دقیقه صبر کنید");
    }
  };

  return (
    <>
      <div className="login-box">
        <div className="login-logo mb-0">
          <b className="bg-warning text-primary px-3">ورود بدون ثبت نام</b>
        </div>

        <div className="card">
          <div className="card-body login-card-body">
            {messageComponent}

            <p className="login-box-msg">کد پیامک شده را وارد کنید</p>
            <form onSubmit={submitFormEnterCodeMobileNumberForLoign}>
              <div className="input-group py-2">
                <input
                  type="number"
                  id="code-sms-mobile"
                  placeholder="کد تایید"
                  className="form-control"
                />
              </div>

              <div className="d-flex justify-content-around  py-2">
                <div>
                  <button
                    type="submit"
                    id="btn-enter-sms-login-code"
                    className="btn  btn-primary "
                  >
                    ورود
                  </button>
                </div>

                <div>
                  <input
                    id="btn-back-to-enter-mobile"
                    className="btn btn-warning"
                    type="button"
                    onClick={() => {
                      clearInterval(timer);
                      returnToEnterUserMobilerForLogin();
                    }}
                    value="بازگشت"
                  />
                </div>
              </div>
            </form>

            <div className="py-2 text-center">
              <input
                className="btn btn-primary"
                id="btn-send-sms-code-login-again"
                value="ارسال مجدد کد"
                type="button"
                onClick={sendSmsLoginCodeAgainHandler}
              />
            </div>

            <div id="countdown" dir="ltr" className="text-center"></div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    isUserLoggedIn: state.main.isUserLoggedIn,
    mobile: state.main.mobile,
    hasMessage: state.main.hasMessage,
    typeMessage: state.main.typeMessage,
    message: state.main.message,
    authStatus: state.main.authStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkSmsCodeMobileForLogin: (action) => {
      dispatch({
        type: authActions.CHECK_SMS_CODE_MOBILE_FOR_LOGIN,
        payload: action,
      });
    },
    sendMobileUserForLoign: (action) => {
      dispatch({
        type: authActions.USER_ENTER_MOBILE_FOR_LOGIN,
        payload: action,
      });
    },
    returnToEnterUserMobilerForLogin: () => {
      dispatch({
        type: authActions.SEND_SMS_LOGIN_CODE_AGAIN,
        payload: null,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginWithMobile);
